import { Link, useLocation } from "react-router-dom";
import { getEventImageUrl } from "../../utils/Helper";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import MainPagination from "../Common/MainPagination";

const EarningListCommission = ({ isError, isLoading, details, getDetails }) => {
  const location = useLocation();
  const items = details?.data?.itemsList || [];

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <section className="event-my-earnings-section" aria-label="Top selling events">
        <h2 className="event-my-earnings-section-title">Top Selling Events</h2>
        <div className="event-my-earnings-table-wrap">
          {items.length > 0 ? (
            <MainPagination getEventsMethod={getDetails} MainData={details}>
              <table className="event-my-earnings-table" aria-label="Top selling events">
                <thead>
                  <tr>
                    <th scope="col">Event</th>
                    <th scope="col">Total Orders</th>
                    <th scope="col">Total Commission</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr
                      key={item._id || index}
                      className="event-my-earnings-row"
                    >
                      <td className="event-my-earnings-cell-event">
                        <Link
                          className="event-my-earnings-event-link"
                          to={`/promoter/earning/${item._id}?redirectUrl=${location.pathname}`}
                        >
                          <img
                            className="event-my-earnings-event-thumb"
                            src={
                              item.mainimage?.[0]?.path
                                ? getEventImageUrl(
                                    item.mainimage[0].path,
                                    "/event/assets/img/sellingevents.png"
                                  )
                                : "/event/assets/img/sellingevents.png"
                            }
                            alt={item.title || ""}
                          />
                          <span>{item.title}</span>
                        </Link>
                      </td>
                      <td>{item.totalOrders}</td>
                      <td>USD {parseFloat(item.totalSale || 0).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </MainPagination>
          ) : (
            <div className="event-my-earnings-empty">No events found</div>
          )}
        </div>
      </section>
    </MainComponentWrapper>
  );
};

export default EarningListCommission;
